export default [
  {
    fieldName: 'Email',
    isRequired: true,
    label: 'E-mail',
    type: 'email',
  },
  {
    fieldName: 'Password',
    isRequired: true,
    label: 'Password',
    type: 'password',
  }
];



// WEBPACK FOOTER //
// ./src/formFields/login.tsx